import { ApiService } from "../..";

export const beforeUploadVoiceCheck = () => {
  return ApiService.baseAction(`voice/before_upload`, {}, "POST");
};
